/*import _ from 'lodash' // import _ from 'lodash';
import VueLodash from 'vue-lodash'
import Vue from 'vue'

window._ = _;
Vue.use(VueLodash, { lodash: _ })*/

// import { startsWith } from 'lodash'
// Object.defineProperty(Vue.prototype, '_.startsWith', { value: startsWith });


import VueLodash from 'vue-lodash'
import Vue from 'vue'

import { get, each, filter, isEmpty, find, merge, kebabCase, isNull,
    map, findIndex, findLastIndex, eachRight, has, isArray, uniq, reject, replace, values, set, sumBy } from 'lodash'

window._ = { get, each, filter, isEmpty, find, merge, kebabCase, isNull,
    map, findIndex, findLastIndex, eachRight, has, isArray, uniq, reject, replace, values, set, sumBy };

Vue.use(VueLodash, { lodash: _ });